import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    source: String,
    text: String,
    copiedText: { type: String, default: "¡Copiado!" },
    flashHtml: String
  }

  static targets = ["label"]

  copy (event) {
    event.preventDefault()

    const value = this.resolveText()
    if (!value) return

    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(value).then(() => {
        this.showFeedback()
      }).catch(() => {
        this.fallbackCopy(value)
      })
    } else {
      this.fallbackCopy(value)
    }
  }

  resolveText () {
    if (this.hasTextValue && this.textValue) {
      return this.textValue
    }

    if (!this.hasSourceValue || !this.sourceValue) return null

    const sourceElement = document.querySelector(this.sourceValue)
    if (!sourceElement) return null

    return sourceElement.value || sourceElement.textContent
  }

  fallbackCopy (text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.style.position = "fixed"
    textarea.style.opacity = "0"
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand("copy")
    document.body.removeChild(textarea)
    this.showFeedback()
  }

  showFeedback () {
    if (this.hasFlashHtmlValue && this.flashHtmlValue.trim() !== "") {
      this.showToast()
      return
    }

    this.showLabelFeedback()
  }

  showLabelFeedback () {
    const label = this.hasLabelTarget ? this.labelTarget : this.element
    if (!this._originalLabel) {
      this._originalLabel = label.textContent.trim()
    }
    label.textContent = this.copiedTextValue
    setTimeout(() => {
      label.textContent = this._originalLabel
    }, 2000)
  }

  showToast () {
    const container = document.getElementById("flash") || document.body
    const wrapper = document.createElement("div")
    wrapper.innerHTML = this.flashHtmlValue.trim()
    // Skip leading comments / whitespace nodes from ViewComponent debug markers.
    const toast = wrapper.querySelector("[data-controller='flash'], [data-controller='bridge--toast']")
      || wrapper.firstElementChild
    if (toast) container.appendChild(toast)
  }
}
